export default function timeConverter(time: number) {
    const dateObject = new Date(time * 1000)
    return {
        year: dateObject.getFullYear().toString(),
        month: (dateObject.getMonth() + 1).toString(),
        day: dateObject.getDate().toString(),
        hour: dateObject.getHours().toString(),
        minute: dateObject.getMinutes().toString(),
        week: dateObject.getDay().toString()
    }
}
